<template>
  <div>
    <el-dialog top="5vh" :visible.sync="display" width="60%"
               :close-on-click-modal="false"
               :close-on-press-escape="false" @closed="closedHandler" center>
      <el-form ref="form" :model="data" :rules="rules" label-width="200px" size="mini" status-icon>
        <h3 class="card-title text-center">{{ $t('role.button.edit_role') }}
          <small>(Fields with <span class="required">*</span> are required)</small>
        </h3>
        <hr>
        <el-form-item label="Name" prop="name">
          <el-input v-model="data.name"></el-input>
        </el-form-item>
        <el-form-item label="Description" prop="description">
          <el-input type="textarea" v-model="data.description"></el-input>
        </el-form-item>
        <el-form-item label="Guard Name" prop="guard_name">
          <el-select v-model="data.guard_name" placeholder="Select guard">
            <el-option label="API" value="api"></el-option>
            <el-option label="Web" value="web"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
            <el-button @click="$emit('close')">{{ $t('button.cancel') }}</el-button>
            <el-button @click="resetForm()">Reset</el-button>
            <el-button type="primary" :loading="loading" @click.prevent="confirmUpdate">{{ $t('button.save') }}</el-button>
        </span>
    </el-dialog>
    <el-dialog title="Warning" :visible.sync="confirmation" width="30%" center append-to-body>
      <span><i class="el-icon-warning"></i>{{$t('role.confirm.update')}}</span>
      <span slot="footer" class="dialog-footer">
                <el-button @click="confirmation = false">{{ $t('button.cancel') }}</el-button>
                <el-button type="primary" @click="updateRole">{{ $t('button.confirm') }}</el-button>
            </span>
    </el-dialog>
  </div>
</template>
<script>
// import moment from 'moment'
export default {
  name: 'role-edit-modal',
  props: ['role'],
  data () {
    return {
      confirmation: false,
      display: true,
      data: {
        id: this.role.id,
        name: this.role.name,
        description: this.role.description,
        guard_name: this.role.guard_name || 'api'
      },
      rules: {
        name: [
          { required: true, message: this.$t('role.validation.name.required'), trigger: ['change', 'blur'] },
          { min: 3, message: this.$t('role.validation.name.length'), trigger: ['change', 'blur'] }
        ],
        description: [
          { required: true, message: this.$t('role.validation.description.required'), trigger: ['change', 'blur'] },
          { min: 5, message: this.$t('role.validation.description.length'), trigger: ['blur', 'change'] }
        ],
        guard_name: [
          { required: true, message: 'Guard name is required', trigger: ['change', 'blur'] }
        ]
      },
      loading: false
    }
  },
  computed: {
  },
  methods: {
    closedHandler () {
      this.$emit('close')
    },
    confirmUpdate () {
      this.confirmation = true
    },
    updateRole () {
      this.confirmation = false
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const info = Object.assign({}, this.data)
          this.loading = true
          try {
            await this.withLoading(async () => {
              const res = await this.$roleService.updateRole(info.id, info)
              this.showSuccess(this.$t('role.message.updated'))
              this.$emit('updated', res.data)
              this.$emit('close', false)
              this.resetForm()
            }, 'loading')
          } catch (error) {
            // Error is already handled by the global interceptor
            console.log('Component caught error in updateRole:', error)
          } finally {
            this.loading = false
          }
        } else {
          return false
        }
      })
    },
    resetForm () {
      this.$refs.form.resetFields()
    }
  },
  mounted () {
  }
}
</script>
<style scoped>
.required {
  color: #ef1900;
  font-weight: bold;
}
</style>
